import { getAccessTokenFromCookie } from "../util/authentication";

import {AWS_EAST_HEALTHCHECK_API_LIST, AWS_WEST_HEALTHCHECK_API_LIST} from '../util/constants';

export const getServiceHealthEast = async (service) => {
    const apiEndpoint = AWS_EAST_HEALTHCHECK_API_LIST[service];
    try {
        const response = await fetch(apiEndpoint, {
            headers: {
                "Content-Type": "application/json",
                authorization: "Bearer " + getAccessTokenFromCookie(),
            },
        });
        return response;
    } catch (error) {
        console.log(error)
    }
}
export const getServiceHealthWest = async (service) => {
    const apiEndpoint = AWS_WEST_HEALTHCHECK_API_LIST[service];
    try {
        const response = await fetch(apiEndpoint, {
            headers: {
                "Content-Type": "application/json",
                authorization: "Bearer " + getAccessTokenFromCookie(),
            },
        });
        return response;
    } catch (error) {
        console.log(error)
    }
}